export default __webpack_public_path__ + "static/media/shuffle.5b439b5f.svg";